import { APIRecord } from "server/services/tables/types/records";
import { Modal, ModalHeader } from "blocks/components/Modal";
import { Text } from "blocks/components/Text";
import { Suspense, useMemo } from "react";
import { Spinner } from "blocks/components/Spinner";
import { trpc } from "utils/trpc";
import { Field } from "blocks/components";
import { styled } from "lib/theme";
import { APIField } from "server/services/tables/types/fields";
import { prettyValue } from "blocks/v2/Table/Block/utils";

const FieldWrapper = styled.div`
  padding: 10px 0;
`;

const InputWrapper = styled.div`
  padding: 0 15px;

  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  column-gap: 10px;

  color: ${({ theme }) => theme.app.colors.text};

  border-radius: 8px;
  border: 2px solid ${({ theme }) => theme.app.colors.lightGray};
  background: ${({ theme }) => theme.app.colors.superLightGray};

  overflow: hidden;

  height: 50px;
  font-size: 17px;
`;

function CardDetailView(props: {
  kanbanId?: string;
  recordId: APIRecord["id"];
  onClosed: () => void;
}) {
  const { data: cardDetailResponse } = trpc.blockKanban.getCardDetails.useQuery(
    {
      kanbanId: props.kanbanId as string,
      recordId: props.recordId,
    },
    {
      enabled: !!props.kanbanId,
    }
  );

  const fieldRecordData = useMemo(() => {
    if (!cardDetailResponse) return;

    return cardDetailResponse.map<{
      field: APIField | undefined;
      value: string | React.ReactElement;
    }>((item) => {
      return {
        field: item.field,
        value: item.field ? prettyValue(item.field, item.value) : "",
      };
    });
  }, [cardDetailResponse]);

  const renderBody = () => {
    if (!fieldRecordData || fieldRecordData.length === 0) return null;

    return fieldRecordData.map((item) => {
      if (!item.field) return null;
      return (
        <FieldWrapper key={item.field.id} tabIndex={-1}>
          <Field
            label={item.field.name}
            isDisabled={true}
            renderInput={() => <InputWrapper>{item.value}</InputWrapper>}
          />
        </FieldWrapper>
      );
    });
  };

  if (!props.kanbanId || !props.recordId) return null;
  return <>{renderBody()}</>;
}

export default function ModalKanbanCardDetail(props: {
  accountId: number;
  kanbanId?: string;
  recordId: APIRecord["id"];
  onClosed: () => void;
}) {
  return (
    <Modal onClosed={props.onClosed}>
      <ModalHeader>
        <Text as="div" type="modalTitle">
          Card details
        </Text>
      </ModalHeader>
      <Suspense fallback={<Spinner height={20} />}>
        <CardDetailView {...props} />
      </Suspense>
    </Modal>
  );
}
